<template>
    <div class="success-page">
        <div class="main">
            <p v-if="active > 0">您的订单已付款成功！</p>
            <p>订单号：<span>{{queryObj.orderNo}}</span></p>
            <div class="commodity">
                <label>商品：{{queryObj.doubi}}{{queryObj.type === 'ks' ? '快币' : '抖币'}}</label>
                <span v-if="active>0">已付款 <b>{{queryObj.money}}.00</b></span>
            </div>

            <div class="success-img" v-if="active == 0">
                <img src="../assets/images/wait.png" width="48" alt="">
                <p>支付中</p>
            </div>
            <div class="success-img" v-else-if="active>0">
                <img src="../assets/images/success.png"  width="48" alt="">
                <p>付款成功</p>
            </div>
            <div class="status-box">
                <van-steps :active="active" finish-icon="checked" active-icon="checked">
                    <van-step>等待付款</van-step>
                    <van-step>付款成功</van-step>
                    <van-step>等待发货</van-step>
                    <van-step>充值到账</van-step>
                </van-steps>
            </div>
            <div class="button" @click="toWx">
                <van-icon name="wechat" size="24" />
                <span> 添加企业微信，领取不定时福利哦</span>
            </div>
            <div class="tips">订单支付成功后，一般1分钟内自动充值到账，高峰时间可能需要排队，如超过30分钟未到账请及时联系客服咨询。</div>
            
            <div class="btn-group">
                <van-button round plain size="normal" type="info" @click="toHome">返回首页</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { payState} from "../api/api";

export default {
    data() {
        return {
            active: 0,
            queryObj: {},
            timer: null,
        }
    },
    created() {
        this.queryObj = this.$route.query;
        this.getPayState(this.queryObj.orderNo);
    },
    methods: {
        getPayState(id) {
            if(!id) return;
            // 0待支付  1支付成功 2待发货 3发货成功  4 发货失败
            this.timer = setInterval(()=> {
                payState(id).then((res) => {
                    const {code, msg, data} = res;
                    if(code === 200) {
                        const state = data.status ? Number(data.status) : '';
                        this.active = state;
                        if(state == 3) {
                            clearInterval(this.timer);
                        } else if(state == 4){
                            this.$toast('发货失败，请咨询客服！');
                        }
                    }
                    
                });
            }, 3000);
        },
        toWx() { 
          if(this.queryObj.orderType == 46) {
            window.location.href = 'https://work.weixin.qq.com/ca/cawcde45142b92c647';
          } else {
            window.location.href = 'https://work.weixin.qq.com/ca/cawcdedb56e3c42811';
          }
            
        },
        toHome() {
            const {orderType} = this.queryObj 
            window.location.href = 'https://wap.ksmvp.cn/'+(orderType == 46 ? 'ks' : '');
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}
</script>
<style lang="less" scoped>
.success-page {
    padding: 10px;
    width: 100vw;
    height: 100vh;
    .main {
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 6px;
        padding: 50px 10px 10px;
        .status-box {
            padding: 0 20px;
            margin-top: 50px;
        }
        p {
            margin-bottom: 5px;
        }
        .commodity {
           display: flex;
           align-items: center;
           justify-content: space-between;
           span {
                font-weight: 600;
                b {
                    color: red;
                    font-size: 20px;
                }
           }
            
        }
        .success-img {
            text-align: center;
            margin: 50px 0 20px;
            p {
                font-weight: 600;
                margin-top: 10px;
            }
        }
    }
    .button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        line-height: 50px;
        width: 90%;
        margin: 20px auto;
        background: #13ce20;
        border-radius: 30px;
        text-align: center;
        color: #fff;
        gap: 7px;
    }
    .tips {
        font-size: 12px;
        color: #999;
        text-align: center;
        line-height: 20px;
        margin: 20px 0 10px;
        
    }
    .btn-group {
        text-align: center;
        margin-top: 20px;
    }
}   
</style>
<style>
.van-step--horizontal .van-step__icon {
        font-size: 16px;
    }
    .van-step__title--active,
    .van-step--finish {
        font-weight: 600;
        color: #333;
    }


</style>